import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { useMatch } from "../lib/MatchContext";

// Shared guard: shows a "pick a match" call-to-action when no match is selected.
// Match-scoped pages should call `const { selectedMatchId } = useMatch();` and
// render <RequireMatch /> when selectedMatchId is falsy.
export default function RequireMatch({ title = "Pick a Match to Begin" }) {
  const { matches, loaded } = useMatch();
  if (!loaded) return <div className="p-8 text-zinc-500 font-mono-live">▓▒░ loading ░▒▓</div>;
  return (
    <div className="p-6 md:p-10" data-testid="require-match">
      <div className="mc-panel p-8 md:p-12 max-w-2xl mx-auto text-center">
        <Trophy className="w-10 h-10 mx-auto text-warnAmber mb-4" strokeWidth={1.4} />
        <div className="mc-label mb-2">Match Selection Required</div>
        <h1 className="font-head font-black text-3xl md:text-4xl uppercase tracking-tight leading-none">{title}</h1>
        <p className="text-zinc-400 mt-4 text-sm max-w-md mx-auto">
          You have access to {matches.length} match{matches.length === 1 ? "" : "es"}. Choose one from the Matches list first — the Command Centre, Pre-Match, Match-Day and Post-Match pages will then show that match's data.
        </p>
        <Link
          to="/matches"
          data-testid="require-match-go"
          className="mt-6 inline-flex items-center gap-2 bg-white text-black px-4 py-2 font-bold uppercase tracking-widest text-xs"
        >
          <Trophy className="w-4 h-4" /> Go to Matches
        </Link>
      </div>
    </div>
  );
}
